import { FunctionComponent, HTMLAttributes } from 'react';

const IconEnvelope: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg {...props} width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.88462 0C1.7392 0 0 1.7392 0 3.88462V21.1154C0 23.2608 1.7392 25 3.88462 25H28.1154C30.2608 25 32 23.2608 32 21.1154V3.88462C32 1.7392 30.2608 0 28.1154 0H3.88462ZM6.22931 4.82593C5.79337 4.48686 5.16509 4.56539 4.82602 5.00134C4.48695 5.43729 4.56548 6.06556 5.00143 6.40463L15.386 14.4816C15.7472 14.7624 16.2528 14.7624 16.6139 14.4816L26.9985 6.40463C27.4345 6.06556 27.513 5.43729 27.174 5.00134C26.8349 4.56539 26.2066 4.48686 25.7707 4.82593L16 12.4253L6.22931 4.82593Z" fill="currentcolor" />
  </svg>
);

export default IconEnvelope;
